<template>
    <div class="invitation-wrapper">
        <div class="bg-invitation">
            <h1>{{ org.name }}</h1>
            <div class="flex justify-center margin-lr-xl">
                <img alt="" src="../../assets/img/invitation-title.png">
            </div>
            <div class="bg-box">
                <div class="bg-box2">
                    <div class="tab-box flex align-center justify-between">
                        <span :class="{'active':type === 1}" @click="type = 1">会员申请</span>
                        <span :class="{'active':type === 2}" @click="type = 2">机构介绍</span>
                    </div>
                    <div v-show="type === 1">
                        <el-form ref="ruleForm" :label-position="'top'" :model="infoForm" class="ruleForm"
                                 label-width="auto">
                            <el-row :gutter="20">
                                <el-col :gutter="24">
                                    <el-form-item label="会员类型">
                                        <el-radio-group v-model="infoForm.type" @change="typeChange">
                                            <el-radio :label="0">机构会员</el-radio>
                                            <el-radio :label="1">个人会员</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col v-for="(item,index) in infoForm.list"
                                        :key="index" :span="24">
                                    <el-form-item v-if="item.type === 1" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-input v-model="item.answer" :placeholder="'请输入' + item.title"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 2" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-input v-model="item.answer" :placeholder="'请输入' + item.title"
                                                  :rows="5" type="textarea"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 3" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <div v-if="item.field && item.field === 'rankId'">
                                            <el-select v-model="item.answer" :placeholder="'请选择' + item.title"
                                                       class="w-all"
                                                       @change="setLevel">
                                                <el-option v-for="option in item.options" :key="option.value"
                                                           :label="option.label"
                                                           :value="option.value"></el-option>
                                            </el-select>
                                        </div>
                                        <div v-else>
                                            <el-select v-model="item.answer" :placeholder="'请选择' + item.title"
                                                       class="w-all"
                                                       clearable>
                                                <el-option v-for="option in item.options" :key="option.value"
                                                           :label="option.label"
                                                           :value="option.value"></el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 4" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-select v-model="item.answer" :placeholder="'请选择' + item.title" class="w-all"
                                                   clearable multiple>
                                            <el-option v-for="option in item.options" :key="option.value"
                                                       :label="option.label"
                                                       :value="option.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 5" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-cascader
                                            v-model="item.answer"
                                            :options="options"
                                            expand-trigger="hover"
                                            filterable
                                            clearable
                                            placeholder="请选择机构所在地"
                                            style="width: 100%;"
                                        >
                                        </el-cascader>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 6" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <infoUpFile :file="item.answer" :index="index" :limit="item.limit"
                                                    :type="item.type"
                                                    @saveFile="saveFile"/>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 7" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <infoUpFile :file="item.answer" :index="index" :limit="item.limit"
                                                    :type="item.type"
                                                    @saveFile="saveFile"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <div class="flex justify-center font-size-lg margin-bottom-sm">
                                        需缴纳会费 <b class="padding-lr-xs font-size-xs" style="color: #ff0000">{{
                                            money
                                        }}</b> 元
                                    </div>
                                    <div class="flex align-center justify-center margin-bottom">
                                        <el-checkbox v-model="checked"></el-checkbox>
                                        <span class="margin-left-xs" style="cursor: pointer"
                                              @click="centerDialogVisible = true"> 请仔细阅读《入会须知》</span>
                                    </div>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label-width="0">
                                        <div class="flex justify-center">
                                            <el-button class="blue-btn big-btn" @click="saveForm('ruleForm')">申请加入
                                            </el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div v-show="type === 2" class="desc-box" v-html="org.content"></div>

                </div>
            </div>
        </div>

        <el-dialog
            :visible.sync="centerDialogVisible"
            center
            title="入会须知"
            width="100%">
            <div v-html="agreement"></div>
            <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
import infoUpFile from "@/components/InfoUpFile";
import rules from "@/utils/rules";
import {regionData} from "element-china-area-data";
import {getApplyRankList, getCompanyUserMoreJson, memberApply} from "@/api/login";

export default {
    name: "invitation",
    data() {
        return {
            type: 1,
            money: '0.00',
            infoForm: {
                type: 0,
                list: [
                    {
                        type: 1,
                        title: '机构名称',
                        field: 'company',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}]
                    }, {
                        type: 1,
                        title: '社会统一信用代码',
                        field: 'creditCode',
                        answer: '',
                        options: [],
                        isMust: false,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}, {
                            min: 18,
                            max: 18,
                            message: '社会统一信用代码为18位',
                            trigger: 'blur'
                        }]
                    }, {
                        type: 3,
                        title: '机构性质',
                        field: 'unitNature',
                        answer: '',
                        options: [
                            {value: 1, label: '机关'},
                            {value: 2, label: '事业单位'},
                            {value: 3, label: '国有企业'},
                            {value: 4, label: '民营企业'},
                            {value: 5, label: '社会团体'},
                            {value: 6, label: '民办非企业单位'},
                            {value: 7, label: '基金会'},
                            {value: 8, label: '其他'}
                        ],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请选择', trigger: 'change'}]
                    }, {
                        type: 3,
                        title: '会员等级',
                        field: 'rankId',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请选择', trigger: 'change'}]
                    }, {
                        type: 1,
                        title: '法人姓名',
                        field: 'farenName',
                        answer: '',
                        options: [],
                        isMust: false,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}]
                    }, {
                        type: 1,
                        title: '法人联系电话',
                        field: 'farenPhone',
                        answer: '',
                        options: [],
                        isMust: false,
                        isSet: false,
                        rules: rules.tel
                    }, {
                        type: 1,
                        title: '联系人姓名',
                        field: 'name',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}]
                    }, {
                        type: 1,
                        title: '联系人电话',
                        field: 'phone',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: rules.tel
                    }, {
                        type: 5,
                        title: '机构地址',
                        field: 'address',
                        answer: [],
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请选择', trigger: 'change'}]
                    }
                ],
            },
            levelList: [],
            checked: false,
            options: regionData,
            org: {
                name: '',
                content: '',
            },
            centerDialogVisible: false,
            agreement: '',
            userMoreJson: []
        }
    },
    created() {
        this.getInformation()
    },
    components: {infoUpFile},
    methods: {
        //  保存表单
        saveForm(formName) {
            this.$refs[formName].clearValidate()
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.checked) return this.$message.error('请仔细阅读并同意《入会须知》！')
                    this.sureSave()
                } else {
                    this.$message.error('信息填写有误，请确认！')
                }
            });

        },
        async sureSave() {
            let _state = await memberApply(JSON.stringify(this.infoForm.list), this.$route.params.id,this.infoForm.type + 1)
            if (_state.status === 200) {
                this.$alert('恭喜您申请成功，请等待机构审核', '温馨提示', {
                    confirmButtonText: '确定',
                    center: true,
                    callback: () => {
                        this.$router.push('/')
                    }
                });

            }

        },
        //  同步附件信息
        saveFile(val) {
            const _index = val[0]
            this.infoForm.list[_index].answer = val[1]
            this.$set(this.infoForm.list, _index, this.infoForm.list[_index])

        },
        setLevel(val) {
            this.levelList.map(item => {
                if (item.id === val) {
                    this.money = item.price
                }
            })
        },
        //  获取表单
        async getInformation() {
            let _data = await getCompanyUserMoreJson(this.$route.params.id)
            // if (_data.status === 200) this.infoForm.list = JSON.parse(_data.data.userMoreJson.user_more_json)
            await this.getLevel()
            this.org = {
                name: _data.data.orgData.morgname,
                content: _data.data.orgData.morgdesc,
            }
            this.agreement = _data.data.ruHuiContent

            this.userMoreJson.push(_data.data.userMoreJson.user_more_json)
            this.userMoreJson.push(_data.data.userPersonalMoreJson ? _data.data.userPersonalMoreJson.user_more_json : '[]')
            console.log(this.userMoreJson)
            this.setJSONData()
        },
        setJSONData() {
            this.infoForm.list = JSON.parse(this.userMoreJson[this.infoForm.type])
            if (this.infoForm.list.length > 0) {
                let _index = this.infoForm.list.findIndex(item => item.title === '法人联系电话')
                if (_index !==-1)  this.infoForm.list[_index].rules = rules.tel
                let _index2 = this.infoForm.list.findIndex(item => item.title === '联系人电话')
                if (_index2 !==-1)  this.infoForm.list[_index2].rules = rules.tel
                this.$set(this.infoForm.list, _index, this.infoForm.list[_index])
                this.$set(this.infoForm.list, _index2, this.infoForm.list[_index2])

                let _index3 = this.infoForm.list.findIndex(item => item.title === '会员等级')
                if (_index3 !==-1) this.$set(this.infoForm.list, _index3, {
                    type: 3,
                    title: '会员等级',
                    field: 'rankId',
                    answer: this.infoForm.list[_index3].answer,
                    options:this.levelList,
                    isMust: true,
                    isSet: false,
                    rules: [{required: true, message: '请输入', trigger: 'change'}]
                })
            }
        },
        typeChange(e) {
            console.log(e)
            this.setJSONData()
        },
        //  获取会员等级列表
        async getLevel() {
            let _data = await getApplyRankList(this.$route.params.id)
            _data.data.map(item => {
                item.value = item.id
                item.label = item.name
            })
            this.levelList = _data.data
            // let _index = this.infoForm.list.findIndex(item => item.title === '会员等级')
            // this.$set(this.infoForm.list, _index, {
            //     type: 3,
            //     title: '会员等级',
            //     field: 'rankId',
            //     answer: this.infoForm.list[_index].answer,
            //     options: _data.data,
            //     isMust: true,
            //     isSet: false,
            //     rules: [{required: true, message: '请输入', trigger: 'change'}]
            // })
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.invitation-wrapper {
    .bg-invitation {
        width: 100%;
        min-height: 100vh;
        padding: 30px 8px;
        background: url(/src/assets/img/invitation-bg.jpg) #587fb0 no-repeat top center;
        background-size: 100%;

        h1 {
            text-align: center;
            font-size: 24px;
            line-height: 36px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-bottom: 20px;
        }

        img {
            width: 100%;
        }
    }

    .bg-box {
        width: 100%;
        margin: 40px auto;
        background-color: #0a2240;
        border-radius: 20px;

        .bg-box2 {
            width: 92%;
            position: relative;
            top: -30px;
            margin: 0 auto;
            padding: 30px;
            min-height: 508px;
            background-image: linear-gradient(147deg,
                #83b7e3 0%,
                #c1dbf1 37%,
                #ffffff 100%);
            border-radius: 20px;


            .tab-box {
                width: 190px;
                height: 50px;
                margin: 0 auto 30px;
                padding: 9px;
                background-color: #0a2240;
                border-radius: 25px;

                span {
                    display: block;
                    width: 84px;
                    height: 38px;
                    text-align: center;
                    line-height: 38px;
                    font-size: 16px;
                    color: #ffffff;
                    border-radius: 19px;
                    cursor: pointer;

                    &.active {
                        color: #0a2240;
                        background-color: #eef8ff;
                    }
                }
            }

            .desc-box {
                font-size: 16px;
                line-height: 200%;
            }
        }
    }
}
</style>